/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskDraftDescription } from './taskDraftDescription';

export interface TaskDraft {
  title: string;
  description?: TaskDraftDescription;
  type?: string;
}
